import type {AnyRouter} from '@tanstack/react-router';

import type {RouteMeta} from './types';

export interface MatchedRouteProps {
  params: Record<string, string>;
  routes: RouteMeta[];
}

/**
 * Resolve the RR3-shaped `params`/`routes` for a pathname synchronously from the
 * route tree, without waiting for `router.state` to catch up with a navigation.
 *
 * `router.getMatchedRoutes` returns a `[matchedRoutes, rawParams, foundRoute]`
 * tuple (router-core >= 1.171.18; earlier versions returned an object).
 */
export function getMatchedRouteProps(router: AnyRouter, pathname: string): MatchedRouteProps {
  const [matchedRoutes = [], rawParams = {}] = router.getMatchedRoutes(pathname) ?? [];
  return {
    params: rawParams,
    routes: matchedRoutes.map((route) => ({
      path: route.path,
      ...((route.options?.staticData ?? {}) as Partial<RouteMeta>)
    }))
  };
}
